export const isModalOpen = (state) => state.modal.open
export const getModalType = (state) => state.modal.type
export const getModalProperties = (state) => state.modal.properties
